import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=55252152&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=55252152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55252152",
  null
  
)

export default component.exports